import { useSearchParams } from "react-router-dom";
import { NexusImportWarning } from "./WebSocketProvider";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  acknowledgeImportValidationWarnings,
  importValidationWarningsKey,
} from "../store/importValidationWarnings";

type ImportValidationWarnings = {
  warnings: NexusImportWarning[] | undefined;
  acknowledge: () => void;
};

/** The unacknowledged Nexus import warnings for the cell currently in the URL, if any. */
const useImportValidationWarnings = (): ImportValidationWarnings => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const filter = searchParams.get("filter");
  const date = searchParams.get("date");
  const key =
    filter && date ? importValidationWarningsKey(filter, date) : undefined;

  const warnings = useAppSelector((state) =>
    key ? state.importValidationWarningsSlice[key] : undefined,
  );

  const acknowledge = (): void => {
    if (key) dispatch(acknowledgeImportValidationWarnings(key));
  };

  return { warnings, acknowledge };
};

export default useImportValidationWarnings;
